import React from 'react';

export const parseToJSON = (str: string | undefined | null) => {
  try {
    if (!str) return {};
    return JSON.parse(str);
  } catch (e) {
    return {};
  }
};
const CoverBlock: React.FC = () => {
  return <></>;
};

export default CoverBlock;
